import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

/* ***Layouts**** */
const FullLayout = lazy(() => import('../layouts/full-layout/FullLayout'));
const BlankLayout = lazy(() => import('../layouts/blank-layout/BlankLayout'));
/* ***End Layouts**** */

const Error = lazy(() => import('../views/authentication/Error'));

/* ****Pages***** */
// const Dashboard = lazy(() => import('../views/dashboard/Dashboard'));
const Checkout = lazy(() => import('../views/checkout'));
const Confirmation = lazy(() => import('../views/checkout/confirmation'));
const Redirect = lazy(() => import('../views/checkout/redirect'));
const RedirectDeviceId = lazy(() => import('../views/checkout/redirectDeviceId'));
const CheckoutReference = lazy(() => import('../views/checkout/checkoutReference'));
const CheckoutSecundary = lazy(() => import('../views/checkout/checkoutSecundary'));
const CheckoutChallenge = lazy(() => import('../views/checkout/checkoutChallenge'));
const ThreeDSChallenge = lazy(() => import('../views/checkout/threeDSChallenge'));
const ThreeDSCollect = lazy(() => import('../views/checkout/threeDSCollect'));
const Reports = lazy(() => import('../views/reports'));
/* ****Routes***** */

const Router = [
  {
    path: '/',
    element: <FullLayout />,
    children: [
      { path: '/', element: <Navigate to="/checkout/:userId/item/:item" /> },
      // { path: '/dashboards/starter', exact: true, element: <Dashboard /> },
      { path: '/checkout/:userId/item/:item', exact: true, element: <Checkout /> },
      { path: '/checkout/:userId/transaction', exact: true, element: <CheckoutReference /> },
      { path: '/checkout/:userId/secundary', exact: true, element: <CheckoutSecundary /> },
      { path: '/3DS/challenge', exact: true, element: <ThreeDSChallenge /> },
      { path: '/cybs/challenge', exact: true, element: <ThreeDSCollect /> },
      { path: '/enrollment', exact: true, element: <CheckoutChallenge /> },
      { path: '/confirmation', exact: true, element: <Confirmation /> },
      { path: '/redirect', exact: true, element: <Redirect /> },
      { path: '/op/:sellerId/redirect', exact: true, element: <RedirectDeviceId /> },
      { path: '/reports', exact: true, element: <Reports /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
